module.exports = __webpack_public_path__ + "img/na.05f127b.svg";